import styled from 'styled-components';

export const InputStepContainer = styled.div`
  display: flex;
  overflow: hidden;
  border-radius: 2px;
  border: 1px solid #dadada;
`;

export const StepButton = styled.button`
  background: #f5f6f7;
  width: 30px;
  height: 32px;
  border: none;
  flex-shrink: 0;
  transition: 0.3s opacity ease-out;
  cursor: pointer;

  &:disabled {
    opacity: 0.75;
    cursor: not-allowed;
  }
`;

export const StepInput = styled.input`
  display: flex;
  justify-content: center;

  width: 100%;
  border: solid #dadada;
  border-width: 0 1px;
  text-align: center;

  outline: none;

  &::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type='number'] {
    -moz-appearance: textfield;
  }

  & .ant-input-number-handler-wrap {
    display: none;
  }

  & .ant-input-number-input-wrap {
    display: flex;
    align-items: center;

    & input {
      text-align: center;
    }
  }
`;
